import API from '../../../../../services/api';

export const DYNAMIC_DASHBOARD_API = {
    /**************** MEJORAS RECAMBISTAS ****************/
    getMejoras: async (userId) => {
        const params = userId ? '?user_id=' + userId : '';
        return API.get('/mejoras-recambista' + params).then(res => res.data);
    },
    newMejora: async (mejora) => {
        return API.post('/mejoras-recambista', mejora).then(res => res.data);
    },
    updateMejora: async (mejora) => {
        return API.put('/mejoras-recambista/' + mejora.id, mejora).then(res => res.data);
    },
    deleteMejora: async (mejoraId) => {
        return API.delete('/mejoras-recambista/' + mejoraId).then(res => res.data);
    },
    /**************** MEJORAS METRICAS ****************/
    getMejorasMetricas: async (userId) => {
        const params = userId ? '?user_id=' + userId : '';
        return API.get('/mejoras-metricas-recambista' + params).then(res => res.data);
    },
    newMejoraMetrica: async (mejora) => {
        return API.post('/mejoras-metricas-recambista', mejora).then(res => res.data);
    },
    updateMejoraMetrica: async (mejora) => {
        return API.put('/mejoras-metricas-recambista/' + mejora.id, mejora).then(res => res.data);
    },
    deleteMejoraMetrica: async (mejoraId) => {
        return API.delete('/mejoras-metricas-recambista/' + mejoraId).then(res => res.data);
    },
    /************** PROCEDIMIENTOS DE MEJORAS **************/
    getProcedimientosMejoras: async (userId) => {
        const params = userId ? '?user_id=' + userId : '';
        return API.get('/procedimientos-mejoras' + params).then(res => res.data);
    },
    newProcedimientoMejora: async (procedimiento) => {
        return API.post('/procedimientos-mejoras', procedimiento).then(res => res.data);
    },
    updateProcedimientoMejora: async (procedimiento) => {
        return API.put('/procedimientos-mejoras/' + procedimiento.id, procedimiento).then(res => res.data);
    },
    deleteProcedimientoMejora: async (procedimientoId) => {
        return API.delete('/procedimientos-mejoras/' + procedimientoId).then(res => res.data);
    },
    /***************** PUNTOS IMPORTANTES *****************/
    getPuntosImportantes: async (userId) => {
        const params = userId ? '?user_id=' + userId : '';
        return API.get('/puntos-importantes' + params).then(res => res.data);
    },
    newPuntoImportante: async (punto) => {
        return API.post('/puntos-importantes', punto).then(res => res.data);
    },
    updatePuntoImportante: async (punto) => {
        return API.put('/puntos-importantes/' + punto.id, punto).then(res => res.data);
    },
    deletePuntoImportante: async (puntoId) => {
        return API.delete('/puntos-importantes/' + puntoId).then(res => res.data);
    }
}